import { CohortService } from '../../services/Cohort.service'
import OktaUserDetails from "../../Helpers/OktaUserDetails"

const state = {
  deleteCohort: ''
}

function getUserId() {
    return new OktaUserDetails().getUserId();
}


// getters
const getters = {
}
// actions
const actions = {
    DeleteCohort({ commit, rootState }, deletingCohortId) {
        let clientId = rootState.UserManagementStore.UserClientId;
        let userId = getUserId();
        //let userName = rootState.Authentication.user.firstName + ' ' + rootState.Authentication.user.lastName;
        let userName = getUserId(); //use userid from UserDetails table to map user details.
        const params = {
            productType: rootState.AppStore.ProductLine.payload,
            clientId: clientId,
            userid: userId,
            moduleId: '4',
            userSettingId: deletingCohortId,
            updatedBy: userName
        }
        return new Promise((resolve, reject) => {
            CohortService.DeleteCohort(
                params,
                apiData => {
                    commit('setDeleteCohort',
                        {
                            apiData: apiData,
                            //deletingCohortId: deletingCohortId
                        }),
                        //console.log(JSON.stringify(apiData));
                        resolve()
                },
                err => {
                    reject(err)
                }
            )
        })
    },
}

// mutations
const mutations = {
    setDeleteCohort(apiData) {
        state.deleteCohort = apiData;
    }
       /* for (var i = 0; i < rootState.UserSettingStore.userSettingData.length; i++) {
            var stateUserSetting = rootState.UserSettingStore.userSettingData[i];
            if (stateUserSetting.userSettingId == deletingCohortId) {
                    newUserSetting.showOnDefault = false;
                }
            }
        }*/
        //state.tblCohortListFilters = userSettingData;
        //state.userSettingData = userSettingData
        //rootState.UserSettingStore.userSettingData = 
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}